module.exports = __webpack_public_path__ + "img/cake.4268a91b.svg";